module.exports = __webpack_public_path__ + "fonts/Quicksand-300-vietnamese1.acc5504.woff2";